import { Movie } from "@mui/icons-material";

export const VideoConfig = {
    type: 8,
    label: 'Vidéo',
    icon: Movie,
    allowedBy: [2],
    autoConfig: true,
}